import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

// This plugin is used by us to create a deep copy of an object (Richtext from Sanity for example)
// when we transit it through the store. If we don't do that we'll have a mutation handling error for
// object having more than a simple top level object. See error that would happen here: 
// https://forum.vuejs.org/t/cloning-an-object-from-vuex-store-throws-mutation-warnings/8547
Vue.use(VueLodash, { name: '$_', lodash })